<template>
  <div>
    <table-header
      class="table-header"
      search
      search-placeholder="Cari produk atau scan barcode"
      search-action="products/getProductStocks"
      :actions="['buttonAdd', 'buttonMore']"
    >
      <template #buttonAdd>
        <b-button
          v-if="canAccess('manage', 'Product')"
          variant="primary"
          class="d-flex align-items-center pl-1"
          :to="{ name: 'products-add-stock'}"
        >
          <img
            src="@/assets/images/icons/barcode.svg"
            width="16"
            class="mr-75"
            alt="Icon"
          >
          Stock In/Out
        </b-button>
      </template>
      <template #buttonMore>
        <table-action
          :actions="tableHeaderAction"
          :data="{}"
        />
      </template>
    </table-header>

    <b-skeleton-table
      v-if="isLoading"
      :rows="5"
      :columns="5"
    />
    <b-table
      v-else
      ref="refInvoiceListTable"
      :items="productStocks.data"
      responsive
      :fields="tableFields"
      primary-key="id"
      show-empty
      empty-text="No matching records found"
      class="stock-table position-relative mh-160"
    >

      <!-- Column: Product -->
      <template #cell(product)="data">
        <b-media vertical-align="center">
          <template #aside>
            <b-img
              rounded
              width="50"
              :src="linkStaging(`${data.item.product.images.length ? data.item.product.images[0].image_url : ''}`, 50, 50)"
              :alt="data.item.product.name"
              @error="(event) => {
                event.target.src = require('@/assets/images/icons/broken-image.svg')
              }"
            />
          </template>
          <span class="font-weight-bold d-block">
            {{ data.item.product.name }}
          </span>
          <small class="text-muted">by {{ data.item.product.merchant.name }}</small>
        </b-media>
      </template>

      <!-- Column: Status -->
      <template #cell(status)="data">
        <b-badge
          v-if="data.item.stock > 3"
          variant="success"
        >
          Tersedia
        </b-badge>
        <b-badge
          v-else-if="data.item.stock === 1"
          variant="warning"
        >
          Tersedia
        </b-badge>
        <b-badge
          v-else
          variant="secondary"
        >
          Kosong
        </b-badge>
      </template>

      <!-- Column: Status -->
      <template #cell(barcode)="data">
        <barcode
          :id="`sku-${data.item.id}`"
          :value="data.item.barcode"
          width="1"
          height="45"
          font-size="12"
        >
          Show this if the rendering fails.
        </barcode>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">
        <div
          v-if="canAccess('manage', 'Product')"
          class="text-nowrap"
        >
          <table-action
            :actions="tableAction"
            :data="data"
          />
        </div>
      </template>
    </b-table>

    <div class="mx-2 mb-2 pagination-tab">
      <pagination
        :data="productStocks.meta"
        action="products/getProductStocks"
      />
    </div>

    <div
      class="d-flex"
      style="max-width: 353px"
    >
      <barcode
        v-if="printedBarcode"
        id="printed-barcode"
        :value="printedBarcode"
        width="3"
        height="100"
        font-size="36"
      >
        Show this if the rendering fails.
      </barcode>
      <div
        id="printed-barcode-img"
        class="text-center"
      >
        <div class="text-clamp-2 s-20 font-weight-bolder">
          {{ printedText }}
        </div>
        <img
          v-if="printedImage"
          :src="printedImage"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import {
  BTable,
  BMedia,
  BImg,
  BSkeletonTable,
  BBadge,
  VBTooltip, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import TableAction from '@/layouts/components/custom/TableAction.vue'
import Pagination from '@/layouts/components/custom/Pagination.vue'
import TableHeader from '@/layouts/components/custom/TableHeader.vue'
import VueBarcode from 'vue-barcode'
import domtoimage from 'dom-to-image-more'

export default {
  components: {
    BSkeletonTable,
    BTable,
    BMedia,
    BImg,
    TableAction,
    Pagination,
    TableHeader,
    BButton,
    BBadge,
    barcode: VueBarcode,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      tableFields: [
        { key: 'product', label: 'Produk' },
        { key: 'variant', label: 'Variant' },
        { key: 'stock', label: 'Stock' },
        { key: 'status', label: 'Status' },
        { key: 'barcode', label: 'Barcode' },
        { key: 'actions', label: '', thStyle: { width: '1%' } },
      ],
      detailProductExternal: '',
      printedBarcode: '',
      printedImage: '',
      printedText: '',
      isShowDetailProductExternal: false,
      isEditUrl: false,
      isShowSwitch: false,
      required,
    }
  },
  computed: {
    ...mapState('products', ['productStocks', 'isLoading']),
    query() {
      return this.$route.query
    },
    tableAction() {
      return [
        {
          access: null,
          to: 'products-edit|id:product.id',
          action: '',
          icon: 'EditIcon',
          title: 'Edit',
        },
        {
          access: null,
          to: null,
          action: data => {
            this.printedBarcode = data.barcode

            setTimeout(() => {
              const node = document.getElementById('printed-barcode')
              domtoimage
                .toJpeg(node)
                .then(image => {
                  this.printedImage = image
                  this.printedText = data.product.name
                  const nodeImage = document.getElementById('printed-barcode-img')

                  domtoimage
                    .toJpeg(nodeImage)
                    .then(imageFull => {
                      setTimeout(() => {
                        const link = document.createElement('a')
                        link.download = `${this.printedBarcode}.jpeg`
                        link.href = imageFull
                        link.click()

                        setTimeout(() => {
                          this.printedImage = ''
                          this.printedBarcode = ''
                          this.printedText = ''
                        }, 100)
                      }, 100)
                    })
                })
            }, 100)
          },
          icon: 'DownloadIcon',
          title: 'Download Barcode',
        },
        {
          access: null,
          to: null,
          action: data => {
            this.printedBarcode = data.barcode

            setTimeout(() => {
              const node = document.getElementById('printed-barcode')
              domtoimage
                .toJpeg(node)
                .then(image => {
                  this.printedImage = image
                  this.printedText = data.product.name

                  setTimeout(() => {
                    window.print()

                    setTimeout(() => {
                      this.printedImage = ''
                      this.printedBarcode = ''
                      this.printedText = ''
                    }, 100)
                  }, 100)
                })
            }, 100)
          },
          icon: 'PrinterIcon',
          title: 'Print Barcode',
        },
      ]
    },
    tableHeaderAction() {
      return [
        {
          access: this.canAccess('manage', 'TransferProduct'),
          to: 'products-switch',
          action: '',
          icon: 'ChevronsRightIcon',
          title: 'Transfer Produk',
        },
      ]
    },
  },
  async created() {
    if (!this.productStocks.data.length) {
      await this.getProductStocks(this.query)
    }
  },
  methods: {
    ...mapActions('products', ['getProductStocks']),
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#printed-barcode-img div {
  line-height: 22px;
  font-family: monospace;
}

#printed-barcode-img {
  background-color: white !important;
  color: #000000 !important;
  padding: 1rem 0.75rem;
}
//@page {
//  size: A4;
//  margin: 0;
//}

@media print {
  @media print {
    @page {
      size: 30mm 20mm;
      margin: 0 !important;
    }
  }
  // Global Styles
  html, body {
    margin: 0 !important;
    padding: 0 !important;
    height: 99%;
    overflow: hidden;
  }
  body {
    margin: 0 !important;
    padding: 0 !important;
  }
  nav.header-navbar {
    display: none;
  }
  .main-menu {
    display: none;
  }
  .header-navbar-shadow {
    display: none !important;
  }
  .content.app-content {
    margin-left: 0;
    //padding-top: 2rem !important;
    margin: 0 !important;
    padding: 0 !important;
    height:100%;
    overflow: hidden;
  }
  .content-header {
    display: none;
  }
  footer.footer {
    display: none;
  }
  .card {
    background-color: transparent;
    box-shadow: none;
    margin: 0 !important;
    padding: 0 !important;
    height:100%;
    overflow: hidden;
  }
  .customizer-toggle {
    display: none !important;
  }

  .invoice-action {
    display: none;
  }

  .table-header {
    display: none !important;
  }

  .stock-table {
    display: none !important;;
  }

  .product-tab-menu {
    display: none !important;;
  }

  .pagination-tab {
    display: none !important;;
  }

  #printed-barcode {
    display: none !important;;
  }

  body * {
    page-break-before: always;
  }

  #printed-barcode-img div {
    font-size: 2.5mm !important;
    line-height: 2.5mm;
    max-width: 40mm;
    margin-top: 0;
    padding-left: 1mm;
    padding-right: 1mm;
  }

  #printed-barcode-img {
    padding: 0 !important;
    margin: 2mm 1.5mm;
  }

  #printed-barcode-img img {
    width: 40mm;
    height: 20mm;
  }
}
</style>
